// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zphm","col":"styles_col__3SLlp"};